module.exports = __webpack_public_path__ + "img/rea-curse.475f48f3.jpg";